import React from 'react';
import DiagramUtils from '../../utils/DiagramUtils';
import DiagramUI from "../DiagramUI";
import Model from "./DateTimeModel";
import moment from "moment"
import AutoRefreshDiagramUI from '../AutoRefreshDiagramUI';
export default class UI extends AutoRefreshDiagramUI {

    state = {};

    constructor(props, context) {
        super(props, context);
    }

    needRefresh() {
        super.needRefresh();

        this.onTime && this.onTime();
    }

    renderTime() {
        let format = this.props.model.dateTimeFormat
        if (format === "custom") format = this.props.model.dateTimeFormatCustom
        return moment().format(format)
    }
    render() {
        return (
            <div className={"diagram-ui " + (this.props.className || "")} style={this.props.model.toStyle()}  >
                {this.renderTime()}
            </div>
        );
    }
}

const type = new Model().getType();
DiagramUtils.register(type, {
    model: Model,
    name: type,
    alias: "时间",
    catalog: "其他",
    svg: "#anticon-Time",
    uiGetter: (model) => <UI model={model} />
});